import { useTranslation } from "react-i18next";

import { Table } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";

import { IReceiptItemsProps } from "./receipt-items.models";

/** Line items as ДПС holds them — names and quantities are never translated. */
export const ReceiptItems = ({ items }: IReceiptItemsProps) => {
  const { t } = useTranslation();
  const { formatPrice } = useFormatters();

  return (
    <Table.ScrollContainer minWidth={420} mt="md">
      <Table verticalSpacing="xs" horizontalSpacing={0}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("receipt.columns.name")}</Table.Th>
            <Table.Th>{t("receipt.columns.quantity")}</Table.Th>
            <Table.Th>{t("receipt.columns.price")}</Table.Th>
            <Table.Th ta="right">{t("receipt.columns.total")}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {items.map((item, index) => (
            <Table.Tr key={`${item.name}-${index}`}>
              <Table.Td>{item.name}</Table.Td>
              <Table.Td c="dimmed">{item.quantity}</Table.Td>
              <Table.Td c="dimmed">{formatPrice(item.price)}</Table.Td>
              <Table.Td ta="right" fw={500}>
                {formatPrice(item.total)}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
};
